<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="menu-bar-container gradient-border-primary">
    <h6 class="text-start mb-0 pt-3 ps-3 text-theme">Gallery</h6>
    <div class="menu-bar-card mb-0 pb-0">
        <a class="menu-item" *ngFor="let item of menuItems" [routerLink]="item.routeUrl" routerLinkActive="active"
            #rla="routerLinkActive" [routerLinkActiveOptions]="{ exact: true }">
            <i class="menu-icon" [class]="item.icon" [class.active-icon]="rla.isActive"></i>
            <p class="menu-label">{{ item.label }}</p>
        </a>
    </div>
</div>